export default __webpack_public_path__ + "static/media/Logo.536400e7.png";